import React from "react";
import {
  Home as HomeIcon,
  BusinessCenter as PortfolioIcon,
  AccountTree as ProjectIcon,
  QuestionAnswer as QueriesIcon,
  Assessment as RiskIcon,
  People as RolesIcon,
  Link as IntegrationIcon,
  Help as HelpIcon,
  Dashboard as DashboardIcon,
  Adjust as AdjustIcon,
  Description as DescriptionIcon,
  Flag as FlagIcon,
  CheckCircle as CheckCircleIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Warning as WarningIcon,
  MonetizationOn as MonetizationOnIcon,
  DescriptionOutlined as DescriptionOutlinedIcon,
  Settings as SettingsIcon,
  ListAlt as ListAltIcon,
  Assessment as AssessmentIcon,
  BarChart as BarChartIcon,
  Map as MapIcon,
  Timeline as TimelineIcon,
  MeetingRoom as MeetingRoomIcon,
  Folder,
  ShoppingCart as ShoppingCartIcon,
  BusinessCenter as BusinessCenterIcon,
  TrendingUp as TrendingUpIcon,
  AttachMoney as AttachMoneyIcon,
  Visibility,
  Lightbulb as LightbulbIcon,
  DonutLarge as DonutLargeIcon,
  FilePresent as FilePresentIcon,
  Schedule as ScheduleIcon,
  ShieldOutlined,
  InfoOutlined as InfoOutlinedIcon,
  CalendarMonth as CalendarMonthIcon,
  Engineering as EngineeringIcon,
  Inventory as InventoryIcon,
} from "@mui/icons-material";
import { ROUTES } from "../utils";
import { useParams } from "react-router-dom";

export interface NavigationItem {
  label: string;
  icon: React.ReactNode;
  path: string;
  comingSoon?: boolean;
  isHiddenInNavigation?: boolean;
  isStandAlone?: boolean;
  items?: NavigationItem[];
  item?: NavigationSection[];
}

export interface NavigationSection {
  title: string;
  smallTitle?: string | null;
  subtitle: string;
  icon: React.ReactNode;
  iconColor: string;
  category?: string | null;
  items: NavigationItem[];
};

export const homeNavigationSection: NavigationSection[] = [
  {
    title: "Home",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: null,
    items: [
      {
        label: "Home",
        icon: <HomeIcon fontSize="medium" />,
        path: ROUTES.DASHBOARD,
      }
    ]
  }
];

export const projectNavigationSections: NavigationSection[] = [
  {
    title: "Project Overview",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "PROJECT OVERVIEW",
    items: [
      {
        label: "Project Dashboard",
        icon: <DashboardIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_DASHBOARD,
      },
      {
        label: "Project Overview",
        icon: <AdjustIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_OVERVIEW,
      },
    ],
  },
  {
    title: "Planning & Execution",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "PLANNING & EXECUTION",
    items: [
      {
        label: "Schedule & Planning",
        icon: <DescriptionIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_SCHEDULE_AND_PLANNING,
      },
      {
        label: "Stage Gates",
        icon: <FlagIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_STAGE_GATES,
      },
      {
        label: "Recurring Tasks",
        icon: <CalendarMonthIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_RECURRING_TASKS,
      }
    ],
  },
  {
    title: "Communication",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "COMMUNICATION",
    items: [
      {
        label: "Queries & RFIs",
        icon: <QuestionAnswerIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_QUERIES,
      },
    ],
  },
  {
    title: "Quality & Safety",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "QUALITY & SAFETY",
    items: [
      {
        label: "Risks & Issues",
        icon: <WarningIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_RISKS_AND_ISSUES,
      },
    ],
  },
  {
    title: "Financial & Commercial",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "FINANCIAL & COMMERCIAL",
    items: [
      {
        label: "Commercials",
        icon: <MonetizationOnIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_COMMERICIALS,
      },
    ],
  },
  {
    title: "Repository",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "REPOSITORY",
    items: [
      {
        label: "Artefact/Docs",
        icon: <DescriptionOutlinedIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_ARTEFACT_AND_DOCUMENTS,
      },
    ],
  },
  {
    title: "Procurement Requests",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "PROCUREMENT REQUESTS",
    items: [
      {
        label: "Material Requests",
        icon: <InventoryIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_MATERIAL_REQUESTS,
      },
      {
        label: "Resource Requests",
        icon: <EngineeringIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_RESOURCE_REQUESTS,
      },
    ],
  },
  {
    title: "Administration",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "ADMINISTRATION",
    items: [
      {
        label: "Configuration",
        icon: <SettingsIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_CONFIGURAION,
        comingSoon: true,
      },
      {
        label: "Activity Logs",
        icon: <ListAltIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS_ACTIVITY_LOGS,
        comingSoon: true,
      },
    ],
  },
];

export const portfolioProjectNavigationSections: NavigationSection[] = [
  {
    title: "Project Overview",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "PROJECT OVERVIEW",
    items: [
      {
        label: "Project Dashboard",
        icon: <DashboardIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_DASHBOARD,
      },
      {
        label: "Project Overview",
        icon: <AdjustIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_OVERVIEW,
      },
    ],
  },
  {
    title: "Planning & Execution",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "PLANNING & EXECUTION",
    items: [
      {
        label: "Schedule & Planning",
        icon: <DescriptionIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_SCHEDULE_AND_PLANNING,
      },
      {
        label: "Stage Gates",
        icon: <FlagIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_STAGE_GATES,
      },
      {
        label: "Recurring Tasks",
        icon: <CalendarMonthIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RECURRING_TASKS,
      }
    ],
  },
  {
    title: "Communication",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "COMMUNICATION",
    items: [
      {
        label: "Queries & RFIs",
        icon: <QuestionAnswerIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_QUERIES,
      },
    ],
  },
  {
    title: "Quality & Safety",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "QUALITY & SAFETY",
    items: [
      {
        label: "Risks & Issues",
        icon: <WarningIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RISKS_AND_ISSUES,
      },
    ],
  },
  {
    title: "Financial & Commercial",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "FINANCIAL & COMMERCIAL",
    items: [
      {
        label: "Commercials",
        icon: <MonetizationOnIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_COMMERICIALS,
      },
    ],
  },
  {
    title: "Repository",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "REPOSITORY",
    items: [
      {
        label: "Artefact/Docs",
        icon: <DescriptionOutlinedIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_ARTEFACT_AND_DOCUMENTS,
      },
    ],
  },
  {
    title: "Procurement Requests",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "PROCUREMENT REQUESTS",
    items: [
      {
        label: "Material Requests",
        icon: <InventoryIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_MATERIAL_REQUESTS,
      },
      {
        label: "Resource Requests",
        icon: <EngineeringIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RESOURCE_REQUESTS,
      },
    ],
  },
  {
    title: "Administration",
    smallTitle: null,
    subtitle: "",
    icon: <></>,
    iconColor: "",
    category: "ADMINISTRATION",
    items: [
      {
        label: "Configuration",
        icon: <SettingsIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_CONFIGURAION,
        comingSoon: true,
      },
      {
        label: "Activity Logs",
        icon: <ListAltIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_ACTIVITY_LOGS,
        comingSoon: true,
      },
    ],
  },
];

export const navigationSections: NavigationSection[] = [
  {
    title: "Performance Optimisation Zone",
    smallTitle: "Performance Zone",
    subtitle: "Portfolio insight & investment monitoring",
    icon: <BarChartIcon />,
    iconColor: "#E84B0F",
    category: "Performance Zone",
    items: [
      {
        label: "Live Progress",
        icon: <MapIcon fontSize="medium" />,
        path: ROUTES.LIVE_PROGRESS,
      },
      {
        label: "Performance Insights",
        icon: <DashboardIcon fontSize="medium" />,
        path: ROUTES.PROGRAMME_DASHBOARD,
      },
      {
        label: "Investment Oversight",
        icon: <AssessmentIcon fontSize="medium" />,
        path: ROUTES.INVESTMENT_OVERSIGHT,
      },
      {
        label: "Geospatial Oversight",
        icon: <MapIcon fontSize="medium" />,
        path: ROUTES.GEOSPATIAL,
      },
      {
        label: "Geospatial Projects",
        icon: <MapIcon fontSize="medium" />,
        path: ROUTES.GEOSPATIAL_PROJECTS,
      },
      {
        label: "Contractor Oversight",
        icon: <BusinessCenterIcon fontSize="medium" />,
        path: ROUTES.CONTRACTOR_OVERSIGHT,
      },
    ],
  },
  {
    title: "Commercial Controller",
    smallTitle: "Commercial Controller",
    subtitle: "Budget, forecasts & procurement pipeline",
    icon: <DescriptionIcon />,
    iconColor: "#8E24AA",
    category: "Commercial Controller",
    items: [
      {
        label: "Forecast Variance",
        icon: <TimelineIcon fontSize="medium" />,
        path: ROUTES.FORECAST_VARIANCE,
      },
      {
        label: "Procurement Pipeline",
        icon: <ShoppingCartIcon fontSize="medium" />,
        path: ROUTES.PROCUREMENT_PIPELINE,
      },
      {
        label: "Commercial Programme Dashboard",
        icon: <BarChartIcon fontSize="medium" />,
        path: ROUTES.COMMERCIAL_DASHBOARD,
      },
      {
        label: "Budget vs Actuals",
        icon: <AttachMoneyIcon fontSize="medium" />,
        path: ROUTES.BUDGETS_VS_ACTUALS,
      },
      {
        label: "Commitments & Accruals",
        icon: <MonetizationOnIcon fontSize="medium" />,
        path: ROUTES.COMMITMENTS_AND_ACCRUALS,
      },
      {
        label: "Trends & Forecasts",
        icon: <TrendingUpIcon fontSize="medium" />,
        path: ROUTES.TRENDS_AND_FORECASTS,
      },
    ],
  },
  {
    title: "Operational Delivery Zone",
    smallTitle: "Operational Oversight",
    subtitle: "Deployment, projects & delivery control",
    icon: <PortfolioIcon />,
    iconColor: "#1E88E5",
    category: "OPERATIONAL OVERSIGHT",
    items: [
      {
        label: "Portfolio Manager",
        icon: <PortfolioIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO,
        items: [
          {
            label: "Add Portfolio",
            icon: <DashboardIcon fontSize="medium" />,
            path: ROUTES.ADD_PORTFOLIO,
            isHiddenInNavigation: true,
          },
          {
            label: "Edit Portfolio",
            icon: <DashboardIcon fontSize="medium" />,
            path: ROUTES.EDIT_PORTFOLIO,
            isHiddenInNavigation: true
          },
          {
            label: "Performance Insights",
            icon: <DashboardIcon fontSize="medium" />,
            path: ROUTES.PORTFOLIO_PROGRAMME_DASHBOARD,
            isHiddenInNavigation: true,
          },
          {
            label: "Performance Insights",
            icon: <DashboardIcon fontSize="medium" />,
            path: ROUTES.PORTFOLIO_PROJECTS,
            isHiddenInNavigation: true,
            items: [
              {
                label: "Projects",
                icon: <ProjectIcon fontSize="medium" />,
                path: ROUTES.PORTFOLIO_PROJECT_DETAILS,
                isHiddenInNavigation: true,
                isStandAlone: true,
                item: portfolioProjectNavigationSections,
              },
            ]
          },
        ]
      },
      {
        label: "Portfolio Projects",
        icon: <DashboardIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROJECT_DETAILS,
        isHiddenInNavigation: true,
        isStandAlone: true,
        item: portfolioProjectNavigationSections,
      },
      {
        label: "Portfolio Programmes",
        icon: <BusinessCenterIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_PROGRAMME_DASHBOARD,
        isHiddenInNavigation: true,
      },
      {
        label: "Project Manager",
        icon: <ProjectIcon fontSize="medium" />,
        path: ROUTES.PROJECTS,
        items: [
          {
            label: "Add Project",
            icon: <DashboardIcon fontSize="medium" />,
            path: ROUTES.ADD_PROJECT,
            isHiddenInNavigation: true,
          },
          {
            label: "Edit Project",
            icon: <DashboardIcon fontSize="medium" />,
            path: ROUTES.EDIT_PROJECT,
            isHiddenInNavigation: true,
          },
          {
            label: "Projects",
            icon: <ProjectIcon fontSize="medium" />,
            path: ROUTES.PROJECTS_DETAILS,
            isHiddenInNavigation: true,
            isStandAlone: true,
            item: projectNavigationSections,
          },
        ]
      },
      {
        label: "Portfolio Projects",
        icon: <DashboardIcon fontSize="medium" />,
        path: ROUTES.PROJECTS_DETAILS,
        isHiddenInNavigation: true,
        isStandAlone: true,
        item: projectNavigationSections,
      },
      {
        label: "Task Manager",
        icon: <CheckCircleIcon fontSize="medium" />,
        path: ROUTES.TASKS,
      },
      {
        label: "Jeopardy Manager",
        icon: <WarningIcon fontSize="medium" />,
        path: ROUTES.JEOPARDY_MANAGER,
      },
      {
        label: "Jeopardy Manager",
        icon: <WarningIcon fontSize="medium" />,
        path: ROUTES.JEOPARDY_MANAGER,
        isHiddenInNavigation: true,
        items: [
          {
            label: "Jeopardy Manager Details",
            icon: <InfoOutlinedIcon fontSize="medium" />,
            path: ROUTES.JEOPARDY_MANAGER_DETAILS,
            isHiddenInNavigation: true,
          }
        ]
      },
    ],
  },
  {
    title: "Collaboration Zone",
    smallTitle: "Communication Zone",
    subtitle: "Engagement, actions & project dialogue",
    icon: <QueriesIcon />,
    iconColor: "#D81B60",
    category: "Communication Zone",
    items: [
      {
        label: "Queries & RFIs",
        icon: <QueriesIcon fontSize="medium" />,
        path: ROUTES.QUERIES,
      },
      {
        label: "Meetings Manager",
        icon: <MeetingRoomIcon fontSize="medium" />,
        path: ROUTES.MEETING_MANAGER,
      },
      {
        label: "Document Manager",
        icon: <Folder fontSize="medium" />,
        path: ROUTES.DOCUMENT_MANAGER,
      },
      // {
      //   label: "Notifications & Escalations",
      //   icon: <NotificationsSharp fontSize="medium" />,
      //   path: "/notifications",
      //   comingSoon: true,
      // },
    ],
  },
  {
    title: "Risk & Compliance Controller",
    smallTitle: "Risk & Compliance",
    subtitle: "Risk, safety & regulatory assurance",
    icon: <ShieldOutlined />,
    iconColor: "#00897B",
    category: "Risk & Compliance",
    items: [
      {
        label: "Risk Dashboard",
        icon: <RiskIcon fontSize="medium" />,
        path: ROUTES.RISK_DASHBOARD,
      },
      {
        label: "Compliance Manager",
        icon: <CheckCircleIcon fontSize="medium" />,
        path: "/compliance",
        comingSoon: true,
      },
      // {
      //   label: "Change Logs",
      //   icon: <HistoryIcon fontSize="medium" />,
      //   path: "/change-logs",
      //   comingSoon: true,
      // },
    ],
  },
  {
    title: "Vision Studio",
    smallTitle: "Vision Studio",
    subtitle: "Predictive modelling & future insights",
    icon: <Visibility />,
    iconColor: "#FFA000",
    category: "Vision Studio",
    items: [
      {
        label: "Scenario Modeller",
        icon: <LightbulbIcon fontSize="medium" />,
        path: "/scenario-modeller",
        comingSoon: true,
      },
      {
        label: "Predict the Future",
        icon: <TrendingUpIcon fontSize="medium" />,
        path: "/predict-the-future",
        comingSoon: true,
      },
      {
        label: "Risk Anticipator",
        icon: <WarningIcon fontSize="medium" />,
        path: "/risk-anticipator",
        comingSoon: true,
      },
    ],
  },
  {
    title: "Reporting Zone",
    smallTitle: "Reporting Zone",
    subtitle: "Insights, analytics & data exports",
    icon: <BarChartIcon />,
    iconColor: "#09AC60",
    category: "Reporting Zone",
    items: [
      {
        label: "Import Manager",
        icon: <DescriptionIcon fontSize="medium" />,
        path: ROUTES.IMPORT_MANAGER,
        items: [
          {
            label: "Import Batch Details",
            icon: <InfoOutlinedIcon fontSize="medium" />,
            path: ROUTES.IMPORT_BATCH_DETAIL,
            isHiddenInNavigation: true,
          }
        ]
      },
      {
        label: "Custom Reports",
        icon: <DonutLargeIcon fontSize="medium" />,
        path: ROUTES.EXPORT_MANAGER,
      },
      {
        label: "Export & Analytics",
        icon: <FilePresentIcon fontSize="medium" />,
        path: "/risk-anticipator",
        comingSoon: true,
      },
      {
        label: "Scheduled Reports",
        icon: <ScheduleIcon fontSize="medium" />,
        path: "/risk-anticipator",
        comingSoon: true,
      },
    ],
  },
  {
    title: "Administration",
    smallTitle: "Administration",
    subtitle: "Configuration, access & platform support",
    icon: <SettingsIcon />,
    iconColor: "#8E24AA",
    category: "ADMINISTRATION",
    items: [
      {
        label: "Portfolio & Programme Setup",
        icon: <SettingsIcon fontSize="medium" />,
        path: ROUTES.PORTFOLIO_SETUP,
        comingSoon: true,
      },
      {
        label: "Roles & Permissions",
        icon: <RolesIcon fontSize="medium" />,
        path: ROUTES.ROLES,
        comingSoon: true,
      },
      {
        label: "Integrations",
        icon: <IntegrationIcon fontSize="medium" />,
        path: ROUTES.INTERGRATIONS,
        comingSoon: true,
      },
      {
        label: "Support & Help",
        icon: <HelpIcon fontSize="medium" />,
        path: ROUTES.SUPPORT,
        comingSoon: true,
      },
    ],
  },
];
